"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);
window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) { // console.log('App beforeReady');
  subscribe('appLoad', function(event) {
    var json = (function () {
      var json = null;
        $.ajax({
            'async': false,
            'global': false,
            'url': 'https://d1liekpayvooaz.cloudfront.net/apps/customizery/option-sets.json?uuid=wellsons',
            'dataType': "json",
            'success': function (data) {
// console.log("data = ", data);
              for(var j = 0; j<data.length; j++){

console.log("url = ", "https://www.wellsons.com.au"+$(".basic_product_data").attr("product-url"), "selector url=", data[j].ruleSets[0][0].selector);
                if(( (data[j].title).toLowerCase() === ($(".basic_product_data").attr("product-title")).toLowerCase() ) ){ //  || data[j].ruleSets[0][0].selector.indexOf($(".basic_product_data").attr("product-url")) > 0
                  //  console.log("found that");
                   console.log("found data=", data[j]);
                  json = data[j];
                }

                if(json == null && data[j].ruleSets[0][0] != undefined){
                  if(data[j].ruleSets[0][0].selector.indexOf($(".basic_product_data").attr("product-url")) > 0 && data[j].ruleSets[0][0].selector === "https://www.wellsons.com.au"+$(".basic_product_data").attr("product-url") ){
                    //  console.log("found in second cond.");
                    json = data[j];
                  }
                } else {
                  break;
                }

//                 if(json == null){
//                   if(data[j].ruleSets[0][0].selector.indexOf($(".basic_product_data").attr("product-url")) > 0){
//                     //  console.log("found in second cond.");
//                     json = data[j];
//                   }
//                 } else {
//                   break;
//                 }

                if(json != null) {
                  console.log("found json=", json);
                }
                 
              }
            }
        });
        return json;
    })();
    console.log("json loaded=", json.inputs);
	$.each(json.inputs, function( index1 , value1 ) {
          // console.log("index1=", value1);                                 
      $.each(json.inputs[index1].values, function( index2, value2 ) {
         
        var var_handle = value2 && value2.variant ? value2.variant.handle : undefined;
        var price = value2 && value2.variant ? value2.variant.price : undefined;

// console.log("var_handle=", price);
        
        if(price != undefined && price != ''){
          if(var_handle!='' && var_handle!=undefined){ 
            jQuery.getJSON(window.Shopify.routes.root + 'products/'+var_handle+'.js', function(product) {
              var var_id = value2.variant.variantId;
              var title = value2.label;
// console.log("title=", title);
               // price = (value2.variant.price); // Gives old pricing when admin price updated.
              price = (product.price)/100;  
              
              // Price updated with attached variant price
              $.each(product.variants, function( k, v ) {
                if(v['id'] == var_id) {
                  price = v['price'] /100;
                }
              });

// console.log("price=", price);
              var swatch_find = '';
              //if(price != undefined || title != undefined ){
                //var swatch_find = $("input.spb-productoptiontextcolor[name='properties["+json.inputs[index1].name+"]'][value='"+title+"']");//$('input.spb-productoptiontextcolor[name="properties['+json.inputs[index1].label+']"][value="'+title+'"]');
              try {
                swatch_find = $("input.spb-productoptiontextcolor[name='properties["+json.inputs[index1].name+"]'][value='"+title+"']");
              }
              catch(err) {
                console.log("error=",err);
              }  
              if (swatch_find=='' || swatch_find==undefined || swatch_find.length <= 0){ //console.log("checkbox");
                	swatch_find = $("input.spb-productoptiontextcolor[type='checkbox'][value='"+title+"']");//console.log("swatch_find=", swatch_find);
              }

              // if (swatch_find=='' || swatch_find==undefined || swatch_find.length <= 0){ //console.log("checkbox");
              //   	swatch_find = $("input.spb-productoptiontextcolor[type='radio'][value='"+title+"']");//console.log("swatch_find=", swatch_find);
              // }
                    
// console.log("swatch_find=", swatch_find);        
              swatch_find.parents(".spb-productoptionswatchwrapper").addClass("custom-swatch-style");
              swatch_find.parents('.spb-productoptionswatchwrapper').find('input').attr("price_value",title+((price!=undefined)?'|'+price:''));
              swatch_find.parents(".spb-productoptionswatchwrapper").find(".spb-productoptionswatch").after("<div class='details'><p>"+title+"</span></h6></div><span class='variant-price'>" +((price!=undefined)?( Shopify.formatMoney((price*100), money_format)):'') +"</span>");
              swatch_find.addClass(swatch_find.parents(".main_div").find(".spb-productdescfont").text().replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ \\\/]/gi, ''));
              //}
              
                //console.log("swatch_find=", swatch_find.parents('.spb-productoptionswatchwrapper').find('input').attr("price_value"));
              if(swatch_find.prop("checked") == true){//console.log("selected=",swatch_find );
              
                //var selected_input = title;//swatch_find.attr("name");
                var selected_value = title;
      
                var varSel = swatch_find;
                var selected_value_from = json.inputs[index1].label;//$(this).parents(".main_div").find(".spb-productdescfont").text();
                var class_remove = selected_value_from.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ⓘ\ \\\/]/gi, '').trim();
      
                var attr_name = class_remove.replace(/ /g, "_");
                       
              if(varSel.parents('.main_div').hasClass("change_selected_image")) { 
                //var bg_image = varSel.parents(".spb-productoptionswatchwrapper").find(".spb-productoptionswatch").css("background-image").replace("url", "");
      
                var img_url = value2.swatch.value;//bg_image.substring(bg_image.indexOf('("') + 1, bg_image.indexOf('")'));
      // 			console.log("img_url=",img_url);
                $(".product-selection-area .selected-product-block img#image_div").attr("src", img_url);
              }
              
              if(price != undefined){
                var current_money = $(".product-selection-area span.total_price").attr("price_money");
                //console.log("current_money =", current_money);
                var substract = $(".product-selection-area span.total_price").attr(attr_name);
                
                var total_price = 0;
                if(current_money){
                	var total_price = parseInt(current_money);
                }
                var price_money = '';
               
                if(substract){
                   total_price = parseInt(current_money) - parseInt(substract);
                }
                
                var final_p = (Shopify.formatMoney(total_price*100 + (parseInt(price)*100), money_format));
              
                $(".product-selection-area span.total_price").attr("price_money", (total_price + parseInt(price)));
                $(".product-selection-area span.total_price").html(final_p+" INC GST");
                $(".product-selection-area span.total_price").attr(attr_name, price);
              }
              $(".product-selection-area .selected-product-block ."+class_remove).remove();
              if(class_remove.indexOf("ChooseYourBaseVariant") >= 0){ //class_remove.indexOf("ChooseYourBaseVariant") >= 0
                $(".tt-swatches-container .tt-options-swatch li a[data-value='"+title+"']").trigger("click");
                $(".product-selection-area .selected-product-block h4.title").after("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ selected_value_from +":</strong></p><p class='"+class_remove+"'>"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format))+'':'') +"</p></div>");
              }
              else{
                $(".product-selection-area .selected-product-block").append("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ selected_value_from +":</strong></p><p class='"+class_remove+"'>"+ title +((price!=undefined)?( ' - '+Shopify.formatMoney((price*100), money_format))+'<span class="remove" remove-val="'+price+'" remove-div="'+class_remove+'">x</span>':'') +"</p></div>");
              }
        		//$(".product-selection-area .selected-product-block").append("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ selected_value_from +":</strong></p><p class='"+class_remove+"'>"+ title +((price!=undefined)?( ' - '+Shopify.formatMoney((price*100), money_format))+'<span class="remove" remove-val="'+price+'" remove-div="'+class_remove+'">x</span>':'') +"</p></div>");
                                                 
              }
            });
          }        
        }else{
          var title = value2.label;
          var swatch_find = '';
                                                              
          //if(price != undefined || title != undefined ){
            //var swatch_find = $("input.spb-productoptiontextcolor[name='properties["+json.inputs[index1].name+"]'][value='"+title+"']");//$('input.spb-productoptiontextcolor[name="properties['+json.inputs[index1].label+']"][value="'+title+'"]');
          try {
            // swatch_find = $("input.spb-productoptiontextcolor[name='properties["+json.inputs[index1].name+"]'][value='"+title+"']");
            swatch_find = $('input.spb-productoptiontextcolor[name="properties['+json.inputs[index1].name+']"][value="'+title+'"]'); // Changes added to overcome ['] related issue on options naming. i.e. - Taphole 10 o'clock
          }
          catch(err) {
  //           console.log("error=",err);
          }  
          if (swatch_find=='' || swatch_find==undefined || swatch_find.length <= 0){ //console.log("checkbox");
                swatch_find = $("input.spb-productoptiontextcolor[type='checkbox'][value='"+title+"']");//console.log("swatch_find=", swatch_find);
          }
          
          
            swatch_find.parents('.spb-productoptionswatchwrapper').find('input').attr("price_value",title+((price!=undefined)?'|'+price:''));
            swatch_find.parents(".spb-productoptionswatchwrapper").find(".spb-productoptionswatch").after("<div class='details'><p>"+title+((price!=undefined && price != '')?( ' - '+Shopify.formatMoney((price*100), money_format)):'') +"</h6></div>");
            swatch_find.addClass(swatch_find.parents(".main_div").find(".spb-productdescfont").text().replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ \\\/]/gi, ''));
          //}
          
            //console.log("swatch_find=", swatch_find.parents('.spb-productoptionswatchwrapper').find('input').attr("price_value"));
          if(swatch_find.prop("checked") == true){//console.log("selected=",swatch_find );
          
            //var selected_input = title;//swatch_find.attr("name");
            var selected_value = title;
  
            var varSel = swatch_find;
            var selected_value_from = json.inputs[index1].label;//$(this).parents(".main_div").find(".spb-productdescfont").text();
            var class_remove = selected_value_from.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ⓘ\ \\\/]/gi, '').trim();
  
            var attr_name = class_remove.replace(/ /g, "_");
                   
          if(varSel.parents('.main_div').hasClass("change_selected_image")) { 
            //var bg_image = varSel.parents(".spb-productoptionswatchwrapper").find(".spb-productoptionswatch").css("background-image").replace("url", "");
  
            var img_url = value2.swatch.value;//bg_image.substring(bg_image.indexOf('("') + 1, bg_image.indexOf('")'));
  // 			console.log("img_url=",img_url);
            $(".product-selection-area .selected-product-block img#image_div").attr("src", img_url);
          }
          
          if(price != undefined && price != ''){
            var current_money = $(".product-selection-area span.total_price").attr("price_money");
            //console.log("current_money =", current_money);
            var substract = $(".product-selection-area span.total_price").attr(attr_name);
            
            var total_price = 0;
            if(current_money){
                var total_price = parseInt(current_money);
            }
            var price_money = '';
           
            if(substract){
               total_price = parseInt(current_money) - parseInt(substract);
            }
            
            var final_p = (Shopify.formatMoney(total_price*100 + (parseInt(price)*100), money_format));
          
            $(".product-selection-area span.total_price").attr("price_money", (total_price + parseInt(price)));
            $(".product-selection-area span.total_price").html(final_p+" INC GST");
            $(".product-selection-area span.total_price").attr(attr_name, price);
          }
            
          $(".product-selection-area .selected-product-block ."+class_remove).remove();
          if(class_remove.indexOf("ChooseYourBaseVariant") >= 0){ //class_remove.indexOf("ChooseYourBaseVariant") >= 0
            $(".tt-swatches-container .tt-options-swatch li a[data-value='"+title+"']").trigger("click");
            $(".product-selection-area .selected-product-block h4.title").after("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ selected_value_from +":</strong></p><p class='"+class_remove+"'>"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format))+'':'') +"</p></div>");
          }
          else{
            $(".product-selection-area .selected-product-block").append("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ selected_value_from +":</strong></p><p class='"+class_remove+"'>"+ title +((price!=undefined)?( ' - '+Shopify.formatMoney((price*100), money_format))+'<span class="remove" remove-val="'+price+'" remove-div="'+class_remove+'">x</span>':'') +"</p></div>");
          }
            //$(".product-selection-area .selected-product-block").append("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ selected_value_from +":</strong></p><p class='"+class_remove+"'>"+ title +((price!=undefined)?( ' - '+Shopify.formatMoney((price*100), money_format))+'<span class="remove" remove-val="'+price+'" remove-div="'+class_remove+'">x</span>':'') +"</p></div>");
                                             
          }
        }
        
      });
      
     });
    
    });

  };
document.addEventListener("DOMContentLoaded", function() {
$(document).on("change", ".tt-swatches-container-js1 a.options-color", function(){
  var data_val = $(this).attr("data-value");
  // console.log("data_val=",data_val);
//   $("div.ChooseYourBaseVarient .ChooseYourBaseVarient_value").html(data_val+" - ")
});

if(!$("body").hasClass("productwith-dropdown-selection")){
$(document).on("change", "#infiniteoptions-container .main_div:not(.allow_multiple) input", function(){
  var full_val = $(this).attr('price_value');
  // console.log("full_val=", full_val);
  //var handle = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
  var title = '',
      price = 0;
  if (full_val != undefined){
   title = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
   price = (full_val.split("|")[1])?full_val.split("|")[1]:'';
  }
  //console.log(title);
  var selected_input = $(this).attr("name");
  var selected_value = full_val;//$(this).val();
  
  var varSel = $(this);
  var selected_value_from = $(this).parents(".main_div").find(".spb-productdescfont:not(.spb-tooltip)").text();//$(this).parents("div[role=group]").find(".spb-productdescfont").text();
  //var class_remove = selected_value_from.replace(/\(.*?\)/g, '').trim();       
  var class_remove = selected_value_from.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ⓘ\ \\\/]/gi, '').trim();

  if(class_remove.indexOf("ChooseYourBaseVariant") >= 0){
    class_remove = 'ChooseYourBaseVariant'; //$(".product-selection-area .selected-product-block .ChooseYourBaseVariant").remove();
  }
  
  //var attr_name = class_remove.replace(/ /g, "_");
        
  
  if(varSel.parents('.main_div').hasClass("change_selected_image")) { //console.log("change img");
    var bg_image = varSel.parents(".spb-productoptionswatchwrapper").find(".spb-productoptionswatch").css("background-image").replace("url", "");
    
    var img_url = bg_image.substring(bg_image.indexOf('("') + 1, bg_image.indexOf('")'));
    
    //console.log("bg_image=", img_url);
    $(".product-selection-area .selected-product-block img#image_div").attr("src", img_url.replace(/"/g, "")); 
  }
  $(".product-selection-area .selected-product-block ."+class_remove).remove();
  
  $( "#infiniteoptions-container input.spb-productoptiontextcolor:checked" ).each(function( index ) { //console.log("change productoptiontextcolor");
                                                                                      
    if($(this).prop("checked") == true){
        if(price != ''){
          //console.log("price add=", price);
          var current_money = $(".product-selection-area span.total_price").attr("price_money");
          //console.log("current_money =", current_money);
          var substract = $(".product-selection-area span.total_price").attr(class_remove);
          // console.log("substract =", substract);
          var total_price = 0;
          if(current_money){
          	var total_price = parseInt(current_money);
          }
          var price_money = '';
            if(substract != '' && substract != undefined){
              total_price = parseInt(current_money) - parseInt(substract); //(parseInt(current_money) - parseInt(substract)) + parseInt(product.price);
            }
          var final_p = (Shopify.formatMoney(total_price*100 + (parseInt(price)*100), money_format));
          
          $(".product-selection-area span.total_price").attr("price_money", (total_price + parseInt(price))); //(total_price - product.price)? total_price : 0
          
          $(".product-selection-area span.total_price").html(final_p+" INC GST");
         
          $(".product-selection-area span.total_price").attr(class_remove, price);
          
        }
      
      }
    
  });
  
  $(".product-selection-area .selected-product-block ."+class_remove).remove();
  if(class_remove.indexOf("ChooseYourBaseVariant") >= 0){
    $(".product-selection-area .selected-product-block .ChooseYourBaseVariant").remove();
  }
  if(class_remove.indexOf("ChooseYourBaseVariant") >= 0){
    //$("")
    console.log("Base Variant Title=", title);
    $(".tt-swatches-container .tt-options-swatch li a[data-value='"+title+"']").trigger("click");
    $(".product-selection-area .selected-product-block h4.title").after("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ selected_value_from +":</strong></p><p class='"+class_remove+"'>"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format))+'':'') +"</p></div>");
  }
  else{
    if(title != '' && title != undefined)
  	$(".product-selection-area .selected-product-block").append("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ selected_value_from +":</strong></p><p class='"+class_remove+"'>"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format))+'<span class="remove" remove-val="'+price+'" remove-div="'+class_remove+'">x</span>':'') +"</p></div>");
  }
});
}

$(document).on("change", "#infiniteoptions-container .main_div.allow_multiple input", function(){
  if($('body').hasClass('productsample-box')){
    var selected_value_from = $(this).parents(".main_div").find(".spb-productdescfont:not(.spb-tooltip)").text();
    var attr_name = selected_value_from.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ \\\/]/gi, '').trim();
    var current_money = $(".product-selection-area span.total_price").attr("price_money");
  	$(".product-selection-area .selected-product-block ."+attr_name).remove();
    var selected_val = $(this).parents(".main_div").find("input[type=hidden]").val().split(",");//$(this).val().split(",");
//     console.log('selected_val=', selected_val);
    if(selected_val.length >= 0 && selected_val != ''){
      for (var i = 0; i < selected_val.length; i++){ 
        var full_val = selected_val[i];
        var title = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
        if(title != '' && title != undefined){ // console.log("code with remove btn");
              $(".product-selection-area .selected-product-block").append("<div class='"+attr_name+"'><p class='"+attr_name+"'><strong>"+ selected_value_from +":</strong></p><p class='"+attr_name+"'>"+ title +"<span class='remove' attr_val='"+title+"' remove_type='checkbox' remove-div='"+attr_name+"'>x</span></p></div>");
        }
      }
    }
    
  } else {
  var selected_value_from = $(this).parents(".main_div").find(".spb-productdescfont:not(.spb-tooltip)").text();
  var attr_name = selected_value_from.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ \\\/]/gi, '').trim();
  var current_money = $(".product-selection-area span.total_price").attr("price_money");
        
  var total_price = 0;
  if(current_money){
    var total_price = parseInt(current_money);
  }
  var price_money = '';
  if(attr_name.indexOf("ChooseYourBaseVariant") >= 0){
    attr_name = 'ChooseYourBaseVariant'; //$(".product-selection-area .selected-product-block .ChooseYourBaseVariant").remove();
  }
        
  $(".product-selection-area .selected-product-block ."+attr_name).remove();
  //var handle = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
  if($(this).prop("checked") == true){
    
    //console.log("selected_val=",$(this));  
    var all_selected = $(this).parents('fieldset').find('input[type=hidden]').attr('price_value');
    $(this).parents('fieldset').find('input[type=hidden]').attr("price_value",((all_selected!=undefined)?all_selected:'')+","+$(this).attr('price_value'));

        var full_val = $(this).attr("price_value");//$(this).val()//selected_val[i];
        console.log("title with issue=", title);
        var title = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
        var price = (full_val.split("|")[1])?full_val.split("|")[1]:'';

        var checkbox_val = $(this).parents(".allow_multiple").find("input[type='hidden']").val();
        if(price != ''){
          var final_p = (Shopify.formatMoney(total_price*100 + (parseInt(price)*100), money_format));
          $(".product-selection-area span.total_price").attr("price_money", (total_price + parseInt(price))); //(total_price - product.price)? total_price : 0

          $(".product-selection-area span.total_price").html(final_p+" INC GST");

          $(".product-selection-area span.total_price").attr(attr_name, price);
        }
    }
  
    if($(this).prop("checked") == false){

      var all_selected = $(this).parents('fieldset').find('input[type=hidden]').attr('price_value').split(",");
      //console.log("selected checkboxes=",all_selected);
      all_selected.splice($.inArray($(this).attr('price_value'), all_selected), 1);
      //console.log("selected checkboxes removed=",all_selected);
      $(this).parents('fieldset').find('input[type=hidden]').attr("price_value",all_selected);

  //     var all_selected = $(this).parents('fieldset').find('input[type=hidden]').attr('price_value_all');
  //     $(this).parents('fieldset').find('input[type=hidden]').attr("price_value",all_selected+","+$(this).attr('price_value'));
      var full_val = $(this).attr("price_value");//$(this).val();//$("");
      var title = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
      var price = (full_val.split("|")[1])?full_val.split("|")[1]:'';
      //console.log("unchecked price=", price);

      if(price != '') {
        var val_unchecked = $(this).val().split("|");
        var current_money = $(".product-selection-area span.total_price").attr("price_money");
        //$(".product-selection-area .selected-product-block div span.[attr_val='"+val_unchecked[0]+"]").click();
        total_price = parseInt(current_money) - parseInt(price);
  
        var final_p = (Shopify.formatMoney(total_price*100, money_format));
        $(".product-selection-area span.total_price").attr("price_money", total_price); //(total_price - product.price)? total_price : 0
  
        $(".product-selection-area span.total_price").html(final_p+" INC GST");
  
        $(".product-selection-area span.total_price").attr(attr_name, price);
      }
    }

    if($(this).parents(".main_div").find("input[type=hidden]").length > 0) {
      var selected_val = $(this).parents(".main_div").find("input[type=hidden]").attr('price_value').split(",");//$(this).val().split(",");
  
      if(selected_val.length >= 0 && selected_val != ''){//console.log("add p");
        //var add_val_ = "<div class='"+attr_name+"'><p><strong>"+ selected_value_from +":</strong></p>";
        for (var i = 0; i < selected_val.length; i++){ 
          var full_val = selected_val[i];
  
          var title = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
          var price = (full_val.split("|")[1])?full_val.split("|")[1]:'';
          //console.log("title=", title);
          //console.log("price=", price);
          if(title != '' && title != undefined){
            $(".product-selection-area .selected-product-block").append("<div class='"+attr_name+"'><p class='"+attr_name+"'><strong>"+ selected_value_from +":</strong></p><p class='"+attr_name+"'>"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format))+'<span class="remove" attr_val="'+title+'" remove-val="'+price+'" remove_type="checkbox" remove-div="'+attr_name+'">x</span>':'') +"</p></div>");
            //add_val_ += "<p class="+attr_name+i+">"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format))+'<span class="remove" attr_val="'+title+'" remove-val="'+price+'" remove-div="'+attr_name+i+'">x</span>':'') +"</p>";
          }
        }
      }
    }
      
  }
});

$(document).on("click", ".product-selection-area .selected-items .remove", function(){
  //console.log("remove");
  if($('body').hasClass('productsample-box')){
  	var remove = $(this).attr('attr_val');
    var remove_div = $(this).attr("remove-div");
    $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").prop("checked", false);
    $(this).parents(".product-selection-area .selected-items div."+remove_div).remove();
  }
  else{
    var remove_div = $(this).attr("remove-div");

    if($(this).attr("remove_type")=="checkbox"){
      var remove = $(this).attr('attr_val');
      var whole_title_price = $(this).attr('attr_val')+"|"+$(this).attr('remove-val');
      //console.log("remove=",remove);
      var all_selected = $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").parents('fieldset').find('input[type=hidden]').attr('price_value').split(",");
      var new_val = $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").parents('fieldset').find('input[type=hidden]').val().split(",");

      all_selected.splice($.inArray(whole_title_price, all_selected), 1);
      new_val.splice($.inArray(remove, new_val), 1);
      //console.log("selected checkboxes removed=",all_selected);
      //$(this).parents('fieldset').find('input[type=hidden]').attr("price_value",all_selected);
      $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").parents('fieldset').find('input[type=hidden]').attr("price_value",all_selected);
      $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").parents('fieldset').find('input[type=hidden]').val(new_val);


      $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").prop("checked", false);
    }else{
      $('input.'+remove_div).prop('checked', false);
    }

    $(this).parents(".product-selection-area .selected-items div."+remove_div).remove();//$(".product-selection-area .selected-items div.AddAccessories").children().length
    //console.log("len=", $(".product-selection-area .selected-items div"+remove_div).children().length);
    //if($(".product-selection-area .selected-items div"+remove_div).children().length <= 1 ){console.log("all blank");$(".product-selection-area .selected-items div."+remove_div).remove();}

    var price = $(this).attr("remove-val");
    var attr_name = $(this).attr("remove-div");
    if(price != ''){
      //console.log("price add=", price);
      var current_money = $(".product-selection-area span.total_price").attr("price_money");
      //console.log("current_money =", current_money);
      var substract = $(".product-selection-area span.total_price").attr(attr_name);
      //console.log("substract =", substract);
      var total_price = parseInt(current_money);
      var price_money = '';
      if(substract != '' && substract != undefined){
        total_price = parseInt(current_money) - parseInt(substract); //(parseInt(current_money) - parseInt(substract)) + parseInt(product.price);
      }

      var final_p = (Shopify.formatMoney(total_price*100, money_format));

      $(".product-selection-area span.total_price").attr("price_money", total_price); //(total_price - product.price)? total_price : 0

      $(".product-selection-area span.total_price").html(final_p+" INC GST");

      $(".product-selection-area span.total_price").attr(attr_name, price);

      // console.log("attr_name=",attr_name);
      // console.log("price=",price);

      if($('.product-selection-area .selected-items div.'+attr_name.toLowerCase()).length <= 0){$(".product-selection-area span.total_price").removeAttr(attr_name);}
    }

  }
});

$(document).on("click", ".main_div.checkbox p.show_hide_options", function(e){ // e.preventDefault();
    $(this).parents(".main_div.checkbox").toggleClass("expand");
    $(this).parents(".main_div.checkbox").find(".show_more").toggleClass("hide");
    $(this).parents(".main_div.checkbox").find(".show_less").toggleClass("hide");
});

if($("body").hasClass("productwith-dropdown-selection")){
  window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {

    subscribe('appLoad', function(event) {
      $(".main_div.checkbox").append("<p class='show_hide_options show_more'>Show More Options</p><p class='show_hide_options show_less hide'>Show Less Options</p>");
    });
    
      /**
   * @param {object} event
   * @param {string} event.detail.name The field name of the input.
   * @param {object} event.detail.element A jQuery object representing the element that added to the DOM (this is the parent <div> that wraps the input and label).
   * @param {object} event.detail.productBundle Details about the bundled product.
   */
    subscribe('productBundleAdd', function(event) {
      // Note: The product variant price returned is cached. You may want to retrieve the latest price.
      window.Shoppad.apps.infiniteoptions.getLatestVariantPrice(event.detail.productBundle, function(productBundle) {
//         console.log(Shopify.formatMoney((event.detail.productBundle.price), money_format));
//         console.log('Latest productBundle price add=', event.detail.productBundle);
        
        fetch('/products/' + event.detail.productBundle.handle + '.js').then(function(response){ return response.json() }).then( 
          function(product){
            let variant = product.variants.find(function(variant){ return variant.id == event.detail.productBundle.variantId })
           
            var curr_pr = parseFloat($(".tt-price span.actual-price").attr("price"));
            curr_pr = curr_pr/100;
            var var_p = parseFloat(variant.price/100);
            var newp = curr_pr+var_p;
            if (newp > 0){
              var selected_val_price = 0;
              if($("[name='properties["+event.detail.productBundle.name+"]']").parents(".main_div").hasClass("checkbox")){
                var selected_val_price = $("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-var-price");
//                 console.log("selected_val_price=",selected_val_price);
              	$("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-var-price", ((selected_val_price!=undefined)?parseFloat(selected_val_price):0) +var_p);
              } else {
              	$("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-var-price", var_p);
              }
              $(".tt-price span.actual-price").text(Shopify.formatMoney((newp*100), money_format));
              $(".tt-price span.actual-price").attr("price", newp*100);
            }
            
            var curr_compareatpr = parseFloat($(".tt-price span.old-price").attr("c_price"));
            curr_compareatpr = curr_compareatpr/100;
            var compareatp = parseFloat(variant.compare_at_price/100);
            var newcompareatp = curr_compareatpr+compareatp;
//             console.log("compareatp=",compareatp);
            if (newcompareatp > 0){
              if($("[name='properties["+event.detail.productBundle.name+"]']").parents(".main_div").hasClass("checkbox")){
                var selected_val_cprice = $("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-compareat-price");
//                 console.log("selected_val_cprice=",selected_val_cprice);
                if(compareatp > 0)$("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-compareat-price", ((selected_val_cprice!=undefined)?parseFloat(selected_val_cprice):0) +compareatp);
              } else {
                $("select[name='properties["+event.detail.productBundle.name+"]']").attr("selected-compareat-price", compareatp);
              }
              $(".tt-price span.old-price").attr("c_price", newcompareatp*100);
              $(".tt-price span.old-price").text(Shopify.formatMoney((newcompareatp*100), money_format));
            }
            
            if(newcompareatp > newp){$(".tt-price span.old-price").removeClass("hide");}else{$(".tt-price span.old-price").addClass("hide");}
           
           
          }
        );
        
      });
    });
    
      /**
   * @param {object} event
   * @param {string} event.detail.name The field name of the input.
   * @param {object} event.detail.element A jQuery object representing the element that added to the DOM (this is the parent <div> that wraps the input and label).
   * @param {object} event.detail.productBundle Details about the bundled product.
   */
    subscribe('productBundleRemove', function(event) {
     
      window.Shoppad.apps.infiniteoptions.getLatestVariantPrice(event.detail.productBundle, function(productBundle) {

        fetch('/products/' + event.detail.productBundle.handle + '.js').then(function(response){ return response.json() }).then( 
          function(product){
            let variant = product.variants.find(function(variant){ return variant.id == event.detail.productBundle.variantId })
           
            var curr_pr = parseFloat($(".tt-price span.actual-price").attr("price"));
            curr_pr = curr_pr/100;
            var var_p = parseFloat(variant.price/100); //parseFloat(event.detail.productBundle.price);
           
            var newp = curr_pr-var_p;
            if (newp > 0){
             
              var selected_val_price = 0;
              if($("[name='properties["+event.detail.productBundle.name+"]']").parents(".main_div").hasClass("checkbox")){
                var selected_val_price = $("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-var-price");
//                 console.log("selected_val_price=",selected_val_price);
              	$("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-var-price", ((selected_val_price!=undefined)?parseFloat(selected_val_price):0) -var_p);
              }
              $(".tt-price span.actual-price").text(Shopify.formatMoney((newp*100), money_format));
              $(".tt-price span.actual-price").attr("price", newp*100);
            }
            
            var curr_compareatpr = parseFloat($(".tt-price span.old-price").attr("c_price"));
            curr_compareatpr = curr_compareatpr/100;
            var compareatp = parseFloat(variant.compare_at_price/100);
            var newcompareatp = curr_compareatpr-compareatp;
            
            var selected_val_cprice = 0;
            if (newcompareatp > 0){
              if($("[name='properties["+event.detail.productBundle.name+"]']").parents(".main_div").hasClass("checkbox")){
                var selected_val_cprice = $("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-compareat-price");
//                 console.log("selected_val_cprice=",selected_val_cprice);
                $("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-compareat-price", ((selected_val_cprice!=undefined)?parseFloat(selected_val_cprice):0) -compareatp);
              }
              $(".tt-price span.old-price").attr("c_price", newcompareatp*100);
              $(".tt-price span.old-price").text(Shopify.formatMoney((newcompareatp*100), money_format));
            }
            
            if(newcompareatp > newp){$(".tt-price span.old-price").removeClass("hide");}else{$(".tt-price span.old-price").addClass("hide");}
            
          }
        );
        
        
      });
    });

  };
}
  });